import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative bg-foreground-900 text-white py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div className="md:col-span-2">
            <h3 className="text-white font-heading text-2xl md:text-3xl font-bold mb-4">
              {t('footer.brand')}
            </h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-md mb-6">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-4">
              {['ri-twitter-x-line', 'ri-telegram-line', 'ri-pinterest-line', 'ri-discord-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/50 transition-all duration-200 cursor-pointer"
                  aria-label={icon.replace('ri-', '').replace('-line', '')}
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <h4 className="text-white/50 text-xs font-semibold uppercase tracking-wider mb-2">
                {t('footer.address')}
              </h4>
              <p className="text-white/70 text-sm">Warszawa, Polska</p>
            </div>
            <div>
              <h4 className="text-white/50 text-xs font-semibold uppercase tracking-wider mb-2">
                {t('footer.email')}
              </h4>
              <p className="text-white/70 text-sm">contact@kakobuyfinds.gay</p>
            </div>
            <div className="relative w-full aspect-[3/2] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20desk%20setup%20with%20mechanical%20keyboard%20artisan%20keycaps%20leather%20desk%20mat%20and%20indoor%20monstera%20plant%20soft%20diffused%20ring%20light%20creating%20gentle%20shadows%20modern%20content%20creator%20workspace%20editorial%20photography%20warm%20walnut%20and%20cream%20tones&width=600&height=400&seq=footer-v2-img&orientation=landscape"
                alt="KakobuyFinds styling"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">
              {t('nav.home')}
            </Link>
            <Link to="/artykul-kakobuy-sheet" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">
              {t('nav.blog')}
            </Link>
            <Link to="/cssbuy-spreadsheet" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">
              CSSBuy
            </Link>
            <Link to="/superbuy-spreadsheet" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">
              Superbuy
            </Link>
            <Link to="/poradnik-bezpieczenstwa" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">
              Bezpieczeństwo
            </Link>
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">
              {t('footer.privacy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}